import { defineStore } from 'pinia'

export let useUserSettingsStore = defineStore('userSettingsStore', {
  state: () => ({
    mapSearchFilter: ['bus-stops'],
    availableMarkers: [],
  }),

  actions: {
    setMapSearchFilter(filter) {
      this.mapSearchFilter = [filter]
    },
    clearFilters() {
      this.mapSearchFilter = ['bus-stops']
    },
    setAvailableMarkers(data) {
      this.availableMarkers = data
    },
  },

  getters: {},
})
